<script setup lang="ts">
const userStore = useUserStore()
const modalStore = useModalStore()
</script>

<template>
  <div class="px-4 py-3 mx-auto max-w-7xl sm:px-6 md:px-8">
    <div class="relative pt-16 pb-16 overflow-hidden bg-white rounded shadow">
      <div class="relative">
        <div class="lg:mx-auto lg:max-w-8xl lg:px-8 lg:grid lg:grid-cols-2 lg:grid-flow-col-dense lg:gap-24">
          <div class="max-w-xl px-4 mx-auto sm:px-6 lg:py-16 lg:max-w-none lg:mx-0 lg:px-0">
            <div>
              <div>
                <span class="flex items-center justify-center w-12 h-12 rounded-md bg-tomate-400">
                  <UIcon name="i-mdi-eye" class="w-6 h-6 text-white" aria-hidden="true" />
                </span>
              </div>
              <div class="mt-6">
                <h2 class="text-3xl font-extrabold tracking-tight text-poivre-800 font-title">
                  Un oeil sur vos rabais préférés
                </h2>
                <p class="mt-4 text-lg text-poivre-500">
                  Suivez vos ingrédients préférés pour ne manquer aucun rabais et soyez averti quand il y a un rabais sur vos produits favoris!
                </p>
                <p class="mt-4 text-lg text-poivre-500">
                  Sur l'application, sélectionnez vos ingrédients favoris et chaque semaine, nous vous présentons les offres des circulaires pour ces aliments, en commençant par les plus avantageuses.
                </p>
                <p class="mt-4 text-lg text-poivre-500">
                  Avec <b>plus de 800 ingrédients disponibles</b> et la possibilité d'en choisir jusqu'à 40 à suivre, planifier votre épicerie et optimiser vos économies ne vous prendra que quelques minutes chaque semaine!
                </p>
                <p class="mt-4 text-lg text-poivre-500">
                  Pour recevoir un aperçu des meilleures offres sur vos aliments préférés directement dans votre boîte courriels à tous les mercredi soirs, activez les <b>Alertes de prix</b>.
                </p>
              </div>
            </div>
          </div>
          <div class="mt-12 sm:mt-16 lg:mt-0">
            <div class="pl-4 -mr-48 sm:pl-6 md:-mr-16 lg:px-0 lg:m-0 lg:relative lg:h-full">
              <img class="w-full shadow-xl lg:absolute lg:left-0 lg:h-full lg:w-auto lg:max-w-none" src="https://glouton.b-cdn.net/site/images/mockups/my_ingredients.jpg" alt="Interface des ingrédients suivis">
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="mt-10 bg-white rounded shadow">
      <div class="px-4 py-12 mx-auto text-center max-w-8xl sm:px-6 lg:py-16 lg:px-8">
        <h2 class="mb-2 text-3xl font-extrabold tracking-tight text-poivre-800 sm:text-4xl font-title">
          <span class="block">Prêt à économiser?</span>
        </h2>
        <p class="text-sm text-poivre-600">
          Un abonnement <ULink :to="$localePath({ name: 'ExtraPage' })" class="underline">
            <span class="font-semibold">Extra</span>
          </ULink> est requis pour utiliser cet outil.
        </p>
        <div v-if="!userStore.user" class="flex justify-center mt-5 space-x-3">
          <UButton type="button" icon="i-mdi-login-variant" label="Connexion" @click="modalStore.openLoginModal" />
          <UButton as="a" :to="$localePath({ name: 'RegisterPage' })" label="Créer un compte" />
        </div>
      </div>
    </div>
  </div>
</template>
